import React from "react";
import { BallTriangle } from "react-loading-icons";
import "./Loading.scss";

const Loading = ({ loading }) => {
  return (
    <div className="load">
      <BallTriangle
        className="loading"
        stroke="#00adb5"
        speed={0.75}
        loading={loading}
      />
    </div>
  );
};

export default Loading;
